import PropTypes from 'prop-types';
import { RadioButtonField } from './';
import { RadioContainer } from '../inputs';

const RadioSwitchFields = ({ name }) => (
  <RadioContainer>
    <RadioButtonField value={false} name={name}>
      Nee
    </RadioButtonField>
    <RadioButtonField value name={name}>
      Ja
    </RadioButtonField>
  </RadioContainer>
);

RadioSwitchFields.propTypes = {
  name: PropTypes.string.isRequired,
};

export default RadioSwitchFields;
